import React from 'react';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const KPILoader: React.FC<any> = (props) => {
  const { uniqKey, small, width = 375 } = props;

  if (small) {
    return (
      <ContentLoader width={width} height={50} uniquekey={uniqKey}>
        <rect width="80" height="10" x="0" y="0" />
        <rect width="60" height="25" x="0" y="17.5" />
      </ContentLoader>
    );
  }
  return (
    <ContentLoader width={width} height={40} uniquekey={uniqKey}>
      <rect width="80" height="10" x="0" y="0" />
      <rect width="60" height="35" x="0" y="17.5" />
    </ContentLoader>
  );
};

export default KPILoader;
